<style lang="scss" scoped>
.navmenu {
  padding: 20px 40px 0;
  background-color: #F6FAFD;
  position: relative;
  .navhead {
     padding: 20px 0 18px;
    .navicon, .navtitle {
      float: left;
    }
    img {
      width: 60px;
      margin-right: 20px;
    }
  }
  .navhead:after{
    content: '';
    clear: both;
    display: block;
  }
  .title {
    font-size: 22px;
    color: #314163;
    margin-bottom: 5px;
  }
  .description {
    font-size: 15px;
    color: gray;
  }
  .tabicon {
    display: inline-block;
    width: 20px;
    height: 20px;
    background-size: 100%;
    vertical-align: middle;
    margin-right: 10px;
  }
  .navi {
    position: absolute;
    right: 0;
    top: 0;
  }
}
</style>
<template>
<div class="navmenu">
  <el-breadcrumb separator="/">
    <el-breadcrumb-item :to="{ path: item.path }" v-for="item in breadcrumbs" :key="item.name">{{item.name}}</el-breadcrumb-item>
  </el-breadcrumb>
  <div class="navhead">
    <!-- <div class="navicon" v-show="!!icon">
      <img :src="icon" alt="">
    </div> -->
    <div class="navicon" v-show="!!icon">
      <img src="../assets/ico_skill11.png" alt="">
    </div>
    <div class="navtitle">
      <p class="title">{{pagetitle}}</p>
      <p class="description">{{introduction}}</p>
    </div>
  </div>
  <el-tabs v-model="$route.path" type="card" @tab-click="tabClick" class="ai-tabs--card" v-if="$route.meta.navprops">
    <el-tab-pane :name="item.subpath&&item.subpath.join('').indexOf($route.path)>-1 || $route.path.indexOf(item.keypath) > -1?$route.path:item.path" v-for="item in $route.meta.navprops.paths" :key="item.keypath" v-if="!hideTabs || hideTabs.join('').indexOf(item.path) === -1">
      <span slot="label">
        <i :class="[($route.path===item.path||(item.subpath&&item.subpath.join('').indexOf($route.path)>-1) || $route.path.indexOf(item.keypath) > -1) ?'active':'', item.icon, 'tabicon']"></i>
        {{item.name}}
      </span>
    </el-tab-pane>
  </el-tabs>
  <img :src="$route.meta.navprops.iconurl" alt="" class="navi" v-if="$route.meta.navprops">
</div>
</template>
<script>
export default {
  name: 'navmenu',
  props: ['breadcrumbs', 'pagetitle', 'introduction', 'icon', 'hideTabs'],
  methods: {
    tabClick (tab, event) {
      var self = this
      setTimeout(function () {
        self.$router.push(tab.name)
      }, 0)
    }
  }
}
</script>



// WEBPACK FOOTER //
// navmenu.vue?5b406ca4